<div class="modal-body scroll-panel w-100-p h-adjust-px">
    <!--h-adjust-px Esto debemos ponerlo por una variable que tome los px y se pongan px-->

    <div class="scroll-panel h-100-p">

        <!-- Data -->
        <div>
            <form [formGroup]="fmCompany" autocomplete="off" class="mt-4">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="d-block"
                            [ngClass]="(fmDet.txtCode?.value && !fmDet.txtCode?.invalid)?'has-value':''">
                            <mat-label>
                                {{ 'companies.lblCompanyKey' | translate }}
                            </mat-label>
                            <input matInput maxlength="10" [formControl]="fmDet.txtCode" [errorStateMatcher]="matcher">
                            <mat-error *ngIf="fmDet.txtCode.hasError('required')">
                                {{ 'common.lblErrorRequired' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="d-block"
                            [ngClass]="(fmDet.txtName?.value && !fmDet.txtName?.invalid)?'has-value':''">
                            <mat-label>
                                {{ 'companies.lblCompanyName' | translate }}
                            </mat-label>
                            <input matInput maxlength="80" [formControl]="fmDet.txtName" [errorStateMatcher]="matcher">
                            <mat-error *ngIf="fmDet.txtName.hasError('required')">
                                {{ 'common.lblErrorRequired' | translate}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="d-block"
                            [ngClass]="(fmDet.txtRFC?.value && !fmDet.txtRFC?.invalid)?'has-value':''">
                            <mat-label>
                                {{ 'companies.lblRFC' | translate }}
                            </mat-label>
                            <input matInput maxlength="13" [formControl]="fmDet.txtRFC" [errorStateMatcher]="matcher">
                            <mat-error *ngIf="fmDet.txtRFC.hasError('required')">
                                {{ 'common.lblErrorRequired' | translate }}
                            </mat-error>
                            <mat-error *ngIf="fmDet.txtRFC.hasError('pattern')">
                                {{ 'common.lblErrorFormating' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="d-block"
                            [ngClass]="(fmDet.txtContactName?.value && !fmDet.txtContactName?.invalid)?'has-value':''">
                            <mat-label>{{ 'companies.lblContactName' | translate }}</mat-label>
                            <input matInput maxlength="50" [formControl]="fmDet.txtContactName"
                                [errorStateMatcher]="matcher" autocomplete="off" (keypress)="onKeyPress($event)"
                                data-type="notdoublespace" (keyup)="modelChanged($event)" data-valid="notnumber">
                            <mat-error *ngIf="fmDet.txtContactName.hasError('required')">
                                {{ 'common.lblErrorRequired' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="d-block"
                            [ngClass]="(fmDet.txtContactEmail?.value && !fmDet.txtContactEmail?.invalid)?'has-value':''">
                            <mat-label>
                                {{ 'companies.lblContactEmail' | translate }}
                            </mat-label>
                            <input matInput maxlength="40" [formControl]="fmDet.txtContactEmail"
                                [errorStateMatcher]="matcher">
                            <mat-error *ngIf="fmDet.txtContactEmail.hasError('required')">
                                {{ 'common.lblErrorRequired' | translate }}
                            </mat-error>
                            <mat-error *ngIf="fmDet.txtContactEmail.hasError('pattern')">
                                {{'companies.txtContactEmailPattern' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field class="example-full-width" appearance="fill"
                            [ngClass]="(fmDet.txtUserId?.value && !fmDet.txtUserId?.invalid)?'has-value':''">
                            <mat-label>
                                {{ 'companies.lblUserName' | translate }}
                            </mat-label>
                            <input matInput maxlength="40" [formControl]="fmDet.txtUserId">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="form-group">
                            <label class="d-block lbl-radios">
                                {{ 'common.lblStatus' | translate }}

                            </label>
                            <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                                [formControl]="fmDet.rbStatusId">
                                <mat-radio-button class="example-radio-button mr-2" *ngFor="let item of catStatus"
                                    [value]="item.value">
                                    {{item.name}}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <hr>

        <!-- Type of identity -->
        <form [formGroup]="fmTypePerson">
            <div>

                <div class="col-lg-12">
                    <div class="form-group">
                        <!-- IS OK FOR TYPE PERSONS --- IOMC
                        <div class="row mt-2">
                            <input type="checkbox" id="physical" formControlName="chckbxFPerson" [value]="true" class="checkbox-blue-disabled" [checked]="true">
                            &nbsp;<span class="fw-w-bold">{{ 'companies.lblNaturalPerson' | translate }}</span>&nbsp;{{ 'companies.lblNaturalPersonSection' | translate }}
                        </div>
                        <div class="row mt-2">
                            <input type="checkbox" id="moral" formControlName="chckbxMPerson" [value]="false" class="checkbox-blue" [checked]="false">
                            &nbsp;<span class="fw-w-bold">{{ 'companies.lblMoralPerson' | translate }}</span>&nbsp;{{ 'companies.lblMoralPersonSection' | translate }}
                        </div> -->
                    </div>
                </div>
                <div class="row opacity-05">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <!-- IS OK FOR TYPE PERSONS --- IOMC
                            <hr> -->
                            <ng-container *ngIf="isEnabled">
                                <mat-slide-toggle [ngClass]="'status-obj'" formControlName="mstLightIdentity"
                                    [checked]="true" (toggleChange)="lightIdentity(false, 1)"></mat-slide-toggle>
                                &nbsp;
                                <label for="mstLightIdentity">{{ 'companies.lblLightIdentityQuestion' |
                                    translate}}</label>
                            </ng-container>
                            <ng-container *ngIf="!isEnabled">
                                <mat-slide-toggle [ngClass]="'status-obj'" formControlName="mstLightIdentity"
                                    [checked]="false" (toggleChange)="lightIdentity(true, 1)"></mat-slide-toggle>
                                &nbsp;
                                <label for="mstLightIdentity">{{ 'companies.lblLightIdentityQuestion' |
                                    translate}}</label>
                            </ng-container>
                        </div>
                    </div>
                </div>

            </div>

            <hr>

            <!--Seccion de modulo de asistencia y evidencia-->
            <div>

                <div class="row mb-3">
                    <div class="col-md-12">
                        <div class="flex justify-content-space-between">
                            <span class="fw-bold title-modal-detail fz-14-px">
                                {{ 'companies.lblAssistance' | translate }}
                            </span>
                        </div>
                        <hr class="line-h-blue-purple-dialogs">
                    </div>
                    <div class="col-lg-12">

                        <mat-slide-toggle [ngClass]="'status-obj'" formControlName="assistanceAndEvidenceSection"
                            [checked]="fmTypePersonG.assistanceAndEvidenceSection.value"
                            (change)="adjustValidatorsBio()"></mat-slide-toggle>
                        &nbsp;
                        <label for="assistanceAndEvidenceSectionId">{{ 'companies.lblAssistanceQuestion' |
                            translate}}</label>

                    </div>
                </div>
                <ng-container *ngIf="fmTypePersonG.assistanceAndEvidenceSection.value">
                    <div class="row" *ngFor="let item of companyEntity?.qconfig">
                        <ng-container *ngIf="item.key === 'A_1'">
                            <div class="col-md-12 ml-3 mt-3">
                                <div class="flex justify-content-space-between">
                                    <span class="fw-bold title-modal-detail fz-14-px">
                                        {{ 'companies.assistance.lblOnboarding' | translate }}
                                    </span>
                                </div>
                                <hr class="line-h-blue-purple-dialogs">
                            </div>
                        </ng-container>

                        <ng-container *ngIf="item.key === 'A_2'">
                            <div class="col-md-12 ml-3 mt-3">
                                <div class="flex justify-content-space-between">
                                    <span class="fw-bold title-modal-detail fz-14-px">
                                        {{ 'companies.assistance.lblEvidence' | translate }}
                                    </span>
                                    <br>
                                </div>
                                <hr class="line-h-blue-purple-dialogs">
                            </div>
                        </ng-container>

                        <ng-container *ngIf="item.key === 'A_3'">
                            <div class="col-md-12 ml-3 mt-3">
                                <div class="flex justify-content-space-between">
                                    <span class="fw-bold title-modal-detail fz-14-px">
                                        {{ 'companies.assistance.lblNotifications' | translate }}
                                    </span>
                                </div>
                                <hr class="line-h-blue-purple-dialogs">
                            </div>
                        </ng-container>

                        <ng-container *ngIf="item.key === 'A_3'; else other_content">
                            <div class="col-md-12 ml-3">
                                <mat-checkbox formControlName="{{item.key}}"
                                    (change)="onChangeCheckQuestion($event, item)">
                                    <span class="item-cb-description ml-2">{{item.question}}</span>
                                </mat-checkbox>

                                <ng-container *ngIf="fmTypePersonG.A_3.value">

                                    <div class="row mt-3 mb-3">
                                        <ng-container
                                            *ngFor="let mail of listEmailToNotifs; let indexMail = index; trackBy: setValueMailNotifs">
                                            <div class="col-lg-6 col-md-6 col-sm-12">
                                                <mat-form-field appearance="outline" class="search-field "
                                                    [ngClass]="(!mail.isRegex && mail.mail !== '') ? 'errorInput' : '' ">
                                                    <mat-label>
                                                        {{ 'companies.lblAdminEmail' | translate }}
                                                    </mat-label>
                                                    <ng-container *ngIf="indexMail !== 0">
                                                        <button class="btn-serch-field"
                                                            (click)="deleteMailNotifs(indexMail)"><mat-icon>delete_outline</mat-icon></button>
                                                    </ng-container>
                                                    <input type="email" id="{{indexMail}}" matInput maxlength="255"
                                                        autocomplete="off" value="{{mail.mail}}"
                                                        (change)="setValueMailNotifs(indexMail, $event)"
                                                        (paste)="setValueMailNotifs(indexMail, $event)" />
                                                </mat-form-field>
                                            </div>
                                        </ng-container>

                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <button
                                                [disabled]="(listEmailToNotifs[listEmailToNotifs.length-1].mail === '')"
                                                (click)="addMailNotifs()" class="btn btn-info w-100-p mt-2"
                                                type="button">
                                                {{'companies.assistance.addMail' | translate }}
                                            </button>
                                        </div>

                                    </div>

                                </ng-container>
                            </div>
                        </ng-container>

                        <ng-template #other_content>
                            <div class="col-md-12 ml-3">
                                <mat-checkbox formControlName="{{item.key}}"
                                    (change)="onChangeCheckQuestion($event, item)">
                                    <span class="item-cb-description ml-2">{{item.question}}</span>
                                </mat-checkbox>
                                <br>
                            </div>

                            <ng-container *ngIf=" (isCbxFaceComparation && item.key === 'A_2')">
                                <ng-container *ngFor="let provider of providersCAECat; let indexQS = index">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                       
                                        <ng-container *ngIf="(1 === provider.type)">                                             
                                            <div class="radio-group radio-group-custom d-block ml-5 mb-2">
                                                <input type="radio" name="clasificacionActual{{provider.type}}"
                                                    id="provider{{provider.providerId}}" [checked]="provider.checked"
                                                    (click)="selectProviderCAE(provider.providerId, provider.type)">
                                                &nbsp;{{ provider.description }}
                                            </div> 
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="( isCbxLiveness &&item.key === 'B_2')">
                                <ng-container *ngFor="let provider of providersCAECat; let indexQS = index">
                                    <div class="col-lg-12 col-md-12 col-sm-12 ">
                                        <ng-container *ngIf="(2 === provider.type)">
                                            <div class="radio-group radio-group-custom d-block ml-5 mb-2">
                                                <input type="radio" name="clasificacionActual{{provider.type}}"
                                                    id="provider{{provider.providerId}}" [checked]="provider.checked"
                                                    (click)="selectProviderCAE(provider.providerId, provider.type)">
                                                &nbsp;{{ provider.description }}
                                            </div>
                                        </ng-container>
                                    </div>
                                </ng-container>

                            </ng-container>

                        </ng-template>




                    </div>
                    <!--Configuracion biostar-->
                    <ng-container *ngIf="fmTypePersonG.B_3.value">
                        <div class="row mt-3 ml-3">
                            <div class="col-md-6">
                                <mat-form-field appearance="outline" class="d-block">
                                    <mat-label>
                                        {{ 'companies.assistance.lblBioStarUser' | translate }}
                                    </mat-label>
                                    <input matInput maxlength="255" type="text" id="txtBioUser"
                                        formControlName="nameUserCAE" autocomplete="off">
                                    <mat-error *ngIf="fmTypePersonG.nameUserCAE.hasError('required')">
                                        {{'common.lblErrorRequired' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <div class="input-group">
                                    <mat-form-field appearance="outline" class="help-block">
                                        <mat-label> {{ 'companies.assistance.lblBioStarPassword' | translate
                                            }}</mat-label>
                                        <input matInput id="passwordCAE" formControlName="passwordCAE"
                                            [type]="showBioStar ? 'text' : 'password'"
                                            [autocomplete]="showBioStar ? 'off' : 'new-password'">
                                        <mat-error *ngIf="fmTypePersonG.passwordCAE.hasError('required')">
                                            {{ 'common.lblErrorRequired' | translate }}
                                        </mat-error>
                                    </mat-form-field>
                                    <div *ngIf="showBioStar" class="input-group-append-01">
                                        <span class="input-group-text-01" style="cursor: pointer;" data-toggle="tooltip"
                                            data-placement="top" title="{{ 'companies.lblHidePassword' | translate }}"
                                            (click)="changeBioStar()">
                                            <i class="fa fa-eye-slash"></i>
                                        </span>
                                    </div>
                                    <div *ngIf="!showBioStar" class="input-group-append-01">
                                        <span class="input-group-text-01" style="cursor: pointer;" data-toggle="tooltip"
                                            data-placement="top" title="{{ 'companies.lblShowPassword' | translate }}"
                                            (click)="changeBioStar()">
                                            <i class="fa fa-eye"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row ml-3">
                            <div class="col-md-6">
                                <div class="form-group2">
                                    <mat-form-field appearance="outline" class="d-block border-color-blue">
                                        <mat-label>{{ 'companies.assistance.lblBioStarServer' | translate
                                            }}</mat-label>
                                        <input matInput type="text" id="txtBioServert" formControlName="serverCAE"
                                            maxlength="255">
                                        <mat-error *ngIf="fmTypePersonG.serverCAE.hasError('required')">
                                            {{ 'common.lblErrorRequired' | translate}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group2">
                                    <mat-form-field appearance="outline" class="d-block border-color-blue">
                                        <mat-label>{{ 'companies.assistance.lblBioStarPort' | translate
                                            }}</mat-label>
                                        <input matInput type="text" id="variable" formControlName="portCAE"
                                            maxlength="5">
                                        <mat-error *ngIf="fmTypePersonG.portCAE.hasError('required')">
                                            {{ 'common.lblErrorRequired' | translate}}
                                        </mat-error>
                                        <mat-error *ngIf="fmTypePersonG.portCAE.hasError('minlength')">
                                            {{ 'companies.txtPortMinlength' | translate }}
                                        </mat-error>
                                        <mat-error *ngIf="fmTypePersonG.portCAE.hasError('pattern')">
                                            {{ 'companies.txtOnlyNums' | translate }}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                    </ng-container>
                </ng-container>


            </div>

            <hr>
        </form>
        <!-- Sections -->
        <div>
            <form [formGroup]="fmSections" autocomplete="off">
                <div class="container-fluid p-2">
                    <div class="modal-header-custom">
                        <div class="flex justify-content-space-between">
                            <span class="fw-bold title-modal-detail fz-14-px">
                                {{ 'companies.lblEnrollmentsSections' | translate }}
                            </span>
                        </div>
                        <hr class="line-h-blue-purple-dialogs">
                    </div>
                    <div class="modal-body body-modal-md">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <div class="alert alert-gray" role="alert">
                                        <span class="lbl-form fz-14-px">
                                            {{'companies.lblEnrollmentsInstructions' | translate }}
                                        </span><span class="lbl-required">*</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="col-lg-12 mb-3">
                                    <i class="fa-brands fa-android text-blue-main mr-2"></i>
                                    <span class="fz-12-px">
                                        {{'companies.lblEnrollmentsAndroid' | translate | uppercase }}
                                    </span>
                                </div>
                                <div class="col-lg-12">
                                    <div class="content fz-14-px">
                                        <div *ngFor="let item of this.sectionCat_movil_android">
                                            <mat-checkbox
                                                (change)="onChangeCheckSection($event, item, 'sectionCat_movil_android')"
                                                checked="{{item.checked}}"
                                                [disabled]="item.disabled || item.alreadySelected">
                                                <span class="item-cb-name ml-2">{{item.name}}:</span>
                                                <span class="item-cb-description ml-2">{{item.description}}</span>
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="col-lg-12 mb-3">
                                    <i class="fa-brands fa-apple text-blue-main mr-2"></i>
                                    <span class="fz-12-px">
                                        {{'companies.lblEnrollmentsiOS' | translate | uppercase }}
                                    </span>
                                </div>
                                <div class="col-lg-12">
                                    <div class="content fz-14-px">
                                        <div *ngFor="let item of this.sectionCat_movil_iOS">
                                            <mat-checkbox
                                                (change)="onChangeCheckSection($event, item, 'sectionCat_movil_iOS')"
                                                checked="{{item.checked}}"
                                                [disabled]="item.disabled || item.alreadySelected">
                                                <span class="item-cb-name ml-2">{{item.name}}:</span>
                                                <span class="item-cb-description ml-2">{{item.description}}</span>
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="col-lg-12 mb-3">
                                    <i class="fa-solid fa-globe text-blue-main mr-2"></i>
                                    <span class="fz-12-px">
                                        {{'companies.lblEnrollmentsWebResponsive' | translate | uppercase }}
                                    </span>
                                </div>
                                <div class="col-lg-12">
                                    <div class="content fz-14-px">
                                        <div *ngFor="let item of this.sectionCat_web_responsive">
                                            <mat-checkbox
                                                (change)="onChangeCheckSection($event, item, 'sectionCat_web_responsive')"
                                                checked="{{item.checked}}"
                                                [disabled]="item.disabled || item.alreadySelected">
                                                <span class="item-cb-name ml-2">{{item.name}}:</span>
                                                <span class="item-cb-description ml-2">{{item.description}}</span>
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="col-lg-12 mb-3">
                                    <i class="fa-solid fa-earth-americas text-blue-main mr-2"></i>
                                    <span class="fz-12-px">
                                        {{'companies.lblEnrollmentsWeb' | translate | uppercase }}
                                    </span>
                                </div>
                                <div class="col-lg-12">
                                    <div class="content fz-14-px">
                                        <div *ngFor="let item of this.sectionCat_web">
                                            <mat-checkbox
                                                (change)="onChangeCheckSection($event, item, 'sectionCat_web')"
                                                checked="{{item.checked}}"
                                                [disabled]="item.disabled || item.alreadySelected">
                                                <span class="item-cb-name ml-2">{{item.name}}: </span>
                                                <span class="item-cb-description ml-2">{{item.description}}</span>
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-lg-6 col-md-4 col-sm-12">
                                <div class="col-lg-12 pt-2">
                                    <span class="py-2 font-weight-bold fz-14-px">
                                        {{'companies.lblOtherDocuments' | translate | uppercase }}
                                    </span>
                                </div>
                                <div class="col-lg-12 pt-3">
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ 'companies.ddlDocuments' | translate }}</mat-label>
                                        <mat-select [formControl]="fmSectionsG.ddlDocuments" enabled="false">
                                            <mat-option *ngFor="let item of this.catDocuments"
                                                value="{{item.value}}">{{item.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>

        <hr>

        <!-- Services -->
        <div>
            <div class="row mt-2">
                <div class="col-lg-12">
                    <div class="form-group">
                        <div class="alert alert-info" role="alert">
                            <span class="lbl-form">
                                {{ 'companies.lblServicesInstructions' | translate }}
                            </span><span class="lbl-required">*</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="scroll-panel">
                        <div *ngFor="let item of this.servicesAllCat">
                            <mat-checkbox (change)="onChangeCheckService($event, item)" checked="{{item.checked}}"
                                [disabled]="!item.enabled || item.alreadySelected" class="ml-3">
                                <span class="item-cb-name ml-2 fz-14-px">{{item.name}}: </span>
                                <span class="item-cb-description ml-2 fz-14-px">{{item.description}}</span>
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 pt-3" *ngIf="this.showDivUrlINE">
                    <form [formGroup]="fmServices" autocomplete="off">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group2">
                                <mat-form-field appearance="outline" class="d-block"
                                    [ngClass]="(fmServicesG.txtUrlINE?.value && !fmServicesG.txtUrlINE?.invalid)?'has-value':''">
                                    <mat-label>URL servicio INE</mat-label>
                                    <input matInput maxlength="80" [formControl]="fmServicesG.txtUrlINE">
                                </mat-form-field>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <hr>

        <!-- Providers -->
        <div>
            <div class="modal-header-custom">
                <div class="flex justify-content-space-between">
                    <span class="fw-bold title-modal-detail fz-14-px">
                        {{ 'companies.lblProvidersOnly' | translate }}
                    </span>
                </div>
                <hr class="line-h-blue-purple-dialogs">
            </div>
            <div class="row">
                <div class="col-lg-12">

                    <ng-container *ngFor="let section of catProvidersSections">

                        <div class="form-group">
                            <div class="alert alert-gray" role="alert">
                                <span class="lbl-form">
                                    {{ "companies.providers."+section.name | translate }}
                                </span>
                            </div>
                        </div>
                        <br>

                        <ng-container *ngFor="let provider of listProviders">

                            <ng-container *ngIf="section.id === provider.type">

                                <div class="radio-group">
                                    <input type="radio" name="clasificacionActual{{provider.type}}"
                                        id="provider{{provider.providerId}}"
                                        (click)="selectProvider(provider.providerId, provider.type, 1)"
                                        [checked]="provider.enabled" [disabled]="provider.disabledFront"> &nbsp;{{
                                    provider.description }}
                                </div>

                                <br>

                            </ng-container>

                        </ng-container>

                    </ng-container>

                </div>
            </div>
        </div>

    </div>

    <br><br><br>

</div>

<div class="modal-footer position-sticky">
    <button class="btn btn-secondary " data-dismiss="modal" (click)="onClose()">
        {{'common.btnCancel' | translate }}
    </button>
    <button [disabled]="fmCompany.invalid || fmTypePerson.invalid" (click)="validatingBioSections()"
        class="btn btn-info " type="submit">
        <i class="fa-regular fa-circle-check"></i>
        <span>
            {{'common.btnSave' | translate }}
        </span>
    </button>
</div>